//Permanent
const brand = 'Depor';
const twitterAccount = "tuitdepor";    
const urlBrand = "https://depor.com";
const urlPortadaEspeciales = "https://especiales.depor.com/especiales/index.html";
const domainMarca = "https://especiales.depor.com/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_general/depor/prod/';
const slugCommonAssets = 'elementos-comunes/';
const urlCommonAssets = `${domainAssets}${slugCommonAssets}`;


//Variable
const socialShareText = `Real Madrid vs Liverpool: 10 datos que debes considerar si vas apostar | ${brand}`;
const slugEspecial = "final-champions-league-real-madrd-vs-liverpool-sabado-28-mayo-datos-estadisticas-apostar-partido-en-vivo-uefa-liga-campeones-multimedia-nndd";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets = `${domainAssets}${slugEspecial}`;
const urlJson = `${domainAssets}${slugEspecial}/json/photogallery.json?bjf`;
const queryStringText = 'dato';

export { 
    brand,
    queryStringText,
    twitterAccount, 
    urlBrand, 
    urlPortadaEspeciales, 
    domainMarca, 
    domainAssets, 
    urlCommonAssets, 
    socialShareText, 
    slugEspecial, 
    urlEspecial, 
    urlAssets, 
    urlJson
}